// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const PublicationList    = lazy(() => import('../../views/publication/list'))
const Publications = [
  {
    
    path: '/publication/list',
    element: <PublicationList />
  }
]

export default Publications